import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  Button,
  TableHeader,
} from "@windmill/react-ui";
import { useState, useEffect, useContext } from "react";
import { Tabs, Tab } from "@mui/material";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import Somethingwentwrong from "pages/Somethingwentwrong";
import BillTable from "components/purchasebill/BillTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import PurchasebillServices from "services/PurchasebillServices";
import PurchasebillDrawer from "components/drawer/PurchasebillDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import { SidebarContext } from "context/SidebarContext";
import sidebar from "routes/sidebar";
import { FiRefreshCcw } from "react-icons/fi";
import { useLocation } from "react-router-dom";

const Driver = () => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const [purchasebill, setPurchaseBill] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0); // Tab state
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [error, setError] = useState(false);
  const { setIsUpdate, isUpdate } = useContext(SidebarContext);
  const [status, setStatus] = useState(false);
  const { billRef, dataTable, serviceData, handleSubmitBill, currentPage } =
    useFilter(purchasebill, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const [exportingData, setExportingData] = useState([]);

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  // const formattedDates = {
  // 	start_date: searchstartDate ? formatDate(searchstartDate) : '',
  // 	end_date: searchendDate ? formatDate(searchendDate) : '',
  // };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const urlType = params.get("type");
    if (urlType !== null) {
      const parsed = Number(urlType);
      if (!isNaN(parsed) && parsed >= 1 && parsed <= 4) {
        setTab(parsed - 1);
      }
    }

    const start = params.get("start");
    const end = params.get("end");

    if (start && end) {
      const parseDate = (str) => {
        const [dd, mm, yyyy] = str.split("-");
        return new Date(yyyy, mm - 1, dd);
      };

      setSearchStartDate(parseDate(start));
      setSearchEndDate(parseDate(end));
    }
  }, [location.search]);

  // Fetch data based on selected tab
  useEffect(() => {
    const fetchDrivers = async () => {
      setLoading(true);
      try {
        var payload = {};

        payload.from = searchstartDate ? formatDate(searchstartDate) : "";
        payload.to = searchendDate ? formatDate(searchendDate) : "";
        payload.type = tab + 1;
        // payload.is_vendor = false;
        // payload.id = id_employee;

        const response = await PurchasebillServices.getpurchaseBill(payload);

        const updatedData =
          response?.data?.map(({ id, vendor_id, ...rest }) => ({
            id,
            vendor_id,
            ...rest,
          })) || [];

        setPurchaseBill(updatedData);
        setStatus(response?.status);

        const finalData = response?.data?.map((item, index) => {
          return {
            "SI.No": index + 1,
            "Reference No": item.ref_no,
            "Client Name": item.client_name,
            "Start Date": item.start_date,
            "End Date": item.end_date,
            "Arrival City": item.arrival,
            "Departure City": item.departure,
            "Selling Price": item.selling_price || "-",
            "Vendor Name": item.vendor_name || "-",
            "Vehicle Type": item.vehicle_type,
            "Trip Advance": item.total_trip_advance_paid,
            "Bill Amount": item.bill_amount || "-",
            "Paid Status": item.paid_status == 0 ? "Unpaid" : "Paid",
            "Profit/Loss": item.profit_label,
            "Profit Percentage": item.profit_percentage,
            Remark: item.remark || "-",
            Status: item.status_label,
          };
        });
        setExportingData(finalData);
      } catch (error) {
        setError(true);
        //console.error("Error fetching drivers:", error);
      } finally {
        setLoading(false);
      }
    };
    if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }

    fetchDrivers();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate, searchstartDate, searchendDate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const handleRefresh = () => {
    setSearchEndDate(null);
    setSearchStartDate(null);
    setIsUpdate(true);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "purchase bill" && perm.view === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "purchase bill" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "purchase bill" && perm.export === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "purchase bill" && perm.edit === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "purchase bill" && perm.delete === 1,
      );

  const getTabName = () => {
    if (tab === 0) return "Add";
    if (tab === 1) return "Unverified";
    if (tab === 2) return "Unapproved";
    if (tab === 3) return "Approved";
    return "";
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={null} title="" />
          <MainDrawer>
            <PurchasebillDrawer id={null} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="Between" />
                    <div className="w-50">
                      <InputSearchDate
                        min={searchstartDate}
                        value={searchendDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={billRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitBill}
                  />
                </div>

                {hideExport && (
                  <ExportDataXlsx
                    title="Driver"
                    exportDataXlsx={exportingData}
                    fileNames={`PurchaseBill_${getTabName()}`}
                    startDate={searchstartDate}
                    endDate={searchendDate}
                  />
                )}

                <Button
                  className="rounded-md h-10 px-8"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Search
                </Button>

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Add"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unverified"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unapproved"
            />

            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Approved"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Reference Number</TableCell>
                        <TableCell>Client Name</TableCell>
                        <TableCell>Travel Date</TableCell>
                        {(tab === 2 || tab === 3) && (
                          <TableCell>Selling Price</TableCell>
                        )}
                        {tab !== 0 && <TableCell>Itinerary</TableCell>}
                        <TableCell>Vendor Name</TableCell>
                        <TableCell>Trip Advance</TableCell>
                        {tab !== 0 && <TableCell>Bill Amount</TableCell>}
                        {tab !== 0 && <TableCell>Bill</TableCell>}
                        {tab === 3 && <TableCell>Paid Status</TableCell>}
                        <TableCell>Remark</TableCell>
                        {(tab === 0 || tab === 1) && (
                          <TableCell>Status</TableCell>
                        )}
                        {tab === 2 && (
                          <>
                            <TableCell>Profit/Loss</TableCell>
                          </>
                        )}

                        <TableCell className="text-center">Actions</TableCell>
                      </tr>
                    </TableHeader>
                    <BillTable
                      driver={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      tab={tab}
                      hideAdd={hideAdd}
                      hideEdit={hideEdit}
                      hideView={hideView}
                      hideDelete={hideDelete}
                      hideExport={hideExport}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Bookings." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Driver;
